import React from 'react'
import BreadCrumbsComponent from '../common/BreadCrumbs'

export default function PrivacyPolicyCrumbs() {
  return (
    <BreadCrumbsComponent firstLevel={"Home"} secondLevel={"Legal"} mainHeading={"Privacy Policy"}/>
  )
}
